import { createFileRoute } from '@tanstack/react-router'
import { WITNESS_ELIGIBLE_ROLES } from '@workspace/utils'
import { requireActiveSubscription, requireRoles } from '@/lib/middleware'
import { WitnessRequestsPage } from '@/features/medication-register/witness-requests-page'

/**
 * The register lines someone asked the signed-in staff member to witness (S8
 * Task 12, R3 = W2). The roles are the shared witness predicate's
 * (`WITNESS_ELIGIBLE_ROLES`, R13), the same one the server uses for every
 * witness — NOT the sidebar's participant/staff split, which files a
 * supported employee on the participant side although the server accepts them.
 */
export const Route = createFileRoute(
  '/_authenticated/_organization/medication-witness/'
)({
  beforeLoad: async () => {
    await requireRoles([...WITNESS_ELIGIBLE_ROLES])
    await requireActiveSubscription()
  },
  component: WitnessRequestsPage,
})
